export const SET_LOADERS_FULL_PAGE = "LOADERS/SET_LOADERS_FULL_PAGE";
